<template>
  <div class="runlist-map-dailog dialog">
    <div class="title">
      <h1>湊Run圖示</h1>
    </div>
    <div class="content">
      <table class="table-line">
        <tr class="none-line" v-for="(col, cindex) in [null].concat(cols)" :key="cindex">
          <td v-for="(row, rindex) in [null].concat(rows)" :key="rindex">
            <div v-if="!row || !col">
              <center>
                <h2>{{ (row || col || '').replace(/^0/, '') }}</h2>
              </center>
            </div>
            <div v-else class="circle-container">
              <div class="circle" :class="{ replace: (kitMap[col + row] || {}).replace }">
                <template v-if="(kitMap[col + row] || {}).replace">
                  <span>{{ (kitMap[col + row] || {}).number }}</span>
                  <span>{{ (kitMap[col + row] || {}).position }}</span>
                </template>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({ orders: [] })
    }
  },
  computed: {
    kitMap () {
      return this.param.datas.reduce((s, c) => ({ ...s, [c.sequencing_plate_well_position]: { replace: c.replace, number: c.extraction_plate_number, position: c.extraction_plate_well_position } }), {})
    },
    // static data
    rows () {
      return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    },
    cols () {
      return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
    }
  },
  created () {
    console.log(this.kitMap)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/runlistMap.vue